import type { AccountListStoreOptions } from '~/types';

export default function useAccountsSearch() {
  const nameSearchFields = 'identity.firstName,identity.lastName,identity.name';
  const globalSearchFields = `id,identity.email,${nameSearchFields}`;

  function pickLongestTerm(input: string | undefined): string | undefined {
    if (!input) return undefined;
    const terms = input.trim().split(/\s+/).filter(Boolean);
    if (terms.length === 0) return undefined;
    if (terms.length === 1) return terms[0];

    return terms.reduce((longest, t) => (t.length > longest.length ? t : longest), terms[0]);
  }

  function computeSearchParams(
    nameFilterValue: string | undefined,
    storeOptions: AccountListStoreOptions
  ): { searchTerm?: string; searchFields?: string } {
    const globalInput = storeOptions.searchTerm?.trim();
    if (globalInput) {
      const longestTerm = pickLongestTerm(globalInput);
      return {
        searchTerm: longestTerm,
        searchFields: globalSearchFields
      };
    }
    const localName = nameFilterValue?.trim();
    if (localName) {
      const longestTerm = pickLongestTerm(localName);
      return {
        searchTerm: longestTerm,
        searchFields: longestTerm ? nameSearchFields : undefined
      };
    }
    return {};
  }

  return { computeSearchParams, pickLongestTerm };
}
